/**
 * Accepts an object and appends startTime, endTime, and date
 *
 * @param {Object} object
 * @param {Moment} The startTime moment
 * @param {Moment} The endTime moment
 * @return {Object}
 *   object: { startTime: "12:30", endTime: "1:30", date: "2021-04-29" }
 */
export function appendTimeToObject({ object, startTime, endTime } = {}) {
  const objectWithTimeUnits = { ...object };

  objectWithTimeUnits.endTime = endTime.format('H:mm');
  objectWithTimeUnits.date = startTime.format('YYYY-MM-DD');
  objectWithTimeUnits.startTime = startTime.format('H:mm');

  return objectWithTimeUnits;
}
